import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { SERVICE_PROVIDERS } from 'modules/graphql/types';
import { HelpToggletip } from 'ui/tooltip';
import { SERVICE_PROVIDER_NAMES } from '../../../../constants';

const InlineFlexContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: ${spacing.quarter};
`;

const ToggletipContainer = styled.div`
  height: ${spacing.plusHalf};
`;

export const SparkpostEliteRadioLabel = () => (
  <InlineFlexContainer>
    <span>{SERVICE_PROVIDER_NAMES[SERVICE_PROVIDERS.SPARKPOST_ELITE]}</span>
    <ToggletipContainer
      onClick={(e) => e.stopPropagation() /* Prevent option selection on click of Toggletip */}
    >
      <HelpToggletip tooltipContent="SparkPost Elite gives you all of the power of the SparkPost cloud email service in a dedicated instance with white-glove service and guaranteed peak sending rates." />
    </ToggletipContainer>
  </InlineFlexContainer>
);
